import { Pipe, PipeTransform } from '@angular/core';

import { BtlHelperService } from '@app/base/services/btl-helper.service';

@Pipe({
    name: 'withoutTaxPipe',
})
export class WithoutTaxPipe implements PipeTransform {
    constructor(private btlHelper: BtlHelperService) {}
    transform(value: number | string, isWithoutTax: boolean, numberFix: number = 2): string {
        value = Number(value);
        if (isWithoutTax) {
            return this.btlHelper.round(value, numberFix);
        }
        return `${value}`;
    }
}
